/* eslint-disable no-param-reassign, global-require */

import moment from 'moment';

import 'moment/locale/en-gb';
import 'moment/locale/fr';

import {getStringForLocaleFromDictionary} from '../../../lib/i18n-common';

const langs = ['en-GB', 'fr-FR'];
const dictionary = {};

langs.forEach((lang) => {
  dictionary[lang.toLowerCase()] = {
    strings: require(`../../../locales/b2c-site-client-${lang}.json`),
  };
});

if (module.hot) {
  langs.forEach((lang) => {
    module.hot.accept(`../../../locales/b2c-site-client-${lang}.json`, () => {
      dictionary[lang.toLowerCase()] = {
        strings: require(`../../../locales/b2c-site-client-${lang}.json`),
      };
    });
  });
}

export const USER_LOCALE = document.getElementsByTagName('html')[0].attr('lang') || 'en-gb';
moment.locale(USER_LOCALE);

export const USER_LANGUAGE = USER_LOCALE.replace(/[\-_].*$/, '') || 'en';

export function __(key, ...params) {
  return getStringForLocaleFromDictionary(dictionary, USER_LOCALE, key, params);
}

window.__ = __;

export function __error(error, ...params) {
  let message;

  if (error && error.code) {
    message = getStringForLocaleFromDictionary(dictionary, USER_LOCALE, `ERROR_MESSAGE_${error.code}`, params);
  }

  if (message == null && process.env.NODE_ENV !== 'production') {
    // Unrecognised error. Log it
    console.error('Unlocalised error');
    console.error(error);
  }

  if (message == null && params[0] && params[0].fallback) {
    message = getStringForLocaleFromDictionary(dictionary, USER_LOCALE, `ERROR_MESSAGE_${params[0].fallback}`, params);
  }

  return message != null ? message :
    getStringForLocaleFromDictionary(dictionary, USER_LOCALE, 'ERROR_MESSAGE_GENERIC', params);
}

window.__error = __error;



// WEBPACK FOOTER //
// ./site/i18n.jsx